module.exports = __webpack_public_path__ + "static/media/personalization-present-banner-01.d7b8cc00.png";